import { registrationStatuses, statuses } from '../constants';

export const LEADER_BOARD_SLIDER = 'leaderboardslider';

// from CMS
export const RACE_STATUSES = {
    notStarted: [statuses.NOT_STARTED],
    active: [statuses.ACTIVE],
    both: [statuses.NOT_STARTED, statuses.ACTIVE]
};

export const RACE_REGISTRATION_STATUSES = {
    notStarted: [registrationStatuses.NOT_STARTED],
    inProgress: [registrationStatuses.IN_PROGRESS],
    all: [
        registrationStatuses.NOT_STARTED,
        registrationStatuses.IN_PROGRESS,
        registrationStatuses.FINISHED,
        registrationStatuses.INTERNAL
    ]
};

export const RACES_ORDER = {
    default: 'default',
    startDate: 'startDate',
    endDate: 'endDate',
    playerJoinStatus: 'playerJoinStatus',
    raceStatus: 'raceStatus'
};

export const RACES_REQUESTS = {
    byIDs: 'byIDs',
    byStatusesGameCode: 'byStatusesGameCode'
};

export const NOTIFICATION_FIELDS = [
    'leaderboardId',
    'status',
    'registrationStatus',
    'leaderboardRules',
    'bannerUrl',
    'leaderboardStartTime',
    'millisecondsTillLeaderboardStart',
    'leaderboardEndTime',
    'millisecondsTillLeaderboardEnd',
    'status',
    'joined',
    'rank',
    'score',
    'eventCount',
    'eventCountLimit',
    'displayName',
    'customAttributes',
    'gamingContextRules',
    'participantsCount'
];
